import { render, staticRenderFns } from "./CreateRequisitionForm.vue?vue&type=template&id=7fb7d70c&scoped=true"
import script from "./CreateRequisitionForm.vue?vue&type=script&lang=js"
export * from "./CreateRequisitionForm.vue?vue&type=script&lang=js"
import style0 from "./CreateRequisitionForm.vue?vue&type=style&index=0&id=7fb7d70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7d70c",
  null
  
)

export default component.exports